import React from 'react';

const PageHeader = ({ icon: Icon, title, description }) => {
  return (
    <div className="max-w-full mx-auto mb-10">
      <div className="flex items-center space-x-3 mb-2">
        {Icon && <Icon size={36} className="text-blue-600" />}
        <h1 className="text-3xl font-bold text-gray-800">{title}</h1>
      </div>
      <p className="text-base text-gray-600 mt-1">{description}</p>
    </div>
  );
};

export default PageHeader;
